import { Stack, Title } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'
import { useAuth } from '~/Auth'
import { LibrarySection } from '~/components/blocks/LibrarySection/LibrarySection'
import { AccountSection } from './-AccountSection'
import { AdminSection } from './-AdminSection'
import { ApiKeysSection } from './-ApiKeysSection'
import { AppearanceSection } from './-AppearanceSection'
import { NavigationSection } from './-NavigationSection'
import { PlaybackSection } from './-PlaybackSection'
import { StreamingSection } from './-StreamingSection'

export const Route = createFileRoute('/_app/settings/')({
  component: SettingsPage,
})

function SettingsPage() {
  const { session } = useAuth()
  const user = session.data?.user as
    | { id: number; name: string; email: string; role?: string }
    | undefined
  const userId = user?.id ?? 0
  const isAdmin = user?.role === 'admin'

  return (
    <Stack gap="lg">
      <Title order={2}>Settings</Title>
      <LibrarySection />
      <PlaybackSection />
      <StreamingSection userId={userId} />
      <NavigationSection userId={userId} />
      <AppearanceSection />
      <AccountSection user={user} userId={userId} />
      <ApiKeysSection />
      {isAdmin && <AdminSection currentUserId={userId} />}
    </Stack>
  )
}
